import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableRow,
  TableHeader,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  FontIcon,
  IconButton,
  IconMenu,
  MenuItem,
} from 'material-ui';
import { toggleAssoicatedTemplates as toggleAssoicatedTemplatesAction } from '../master-template/__storeFiles__/actions';
import {
  updateSecondaryTemplateProps as updateSecondaryTemplatePropsAction,
  renameTemplate as renameTemplateAction,
  deleteTemplate as deleteTemplateAction,
} from './__storeFiles__/actions';
import ApplyMasterIcon from 'material-ui/svg-icons/hardware/device-hub';
import MasterIcon from 'material-ui/svg-icons/action/extension';
import injectStyleSheet from 'react-jss';
import { push as pushAction } from 'react-router-redux';
import moment from 'moment';
import { getTemplateStatusColor } from '../contractingUtils';
import { Link } from 'react-router';
import CancelConfirm from '../template-list/list/cancel-confirm-buttons';

const styles = {
  cell: { padding: 0, textAlign: 'center', height: '40px', overflow: 'visible' },
};

class masterTemplateList extends React.Component {
  goToSecondary = id => () => this.props.push(`/contracting/master-template/${id}`);
  goToAssociatedTemplates = id => () => {
    this.goToSecondary(id)();
    this.props.toggleAssoicatedTemplates();
  };
  render() {
    const {
      list,
      classes: css,
      push,
      updateSecondaryTemplateProps,
      deleteTemplate,
      renameTemplate,
    } = this.props;
    return (
      <div>
        <Table
          bodyStyle={{ overflow: 'visible' }}
          style={{ overflow: 'visible' }}
          wrapperStyle={{ overflow: 'visible' }}
        >
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn colSpan="15" style={{ height: '40px' }}>
                Name
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="3" style={styles.cell}>
                Associated Templates
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="3" style={styles.cell}>
                Status
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="3" style={styles.cell}>
                Modified
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="2" style={styles.cell}>
                Actions
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} style={{ overflow: 'visible' }}>
            {list.map(
              (
                { _id, templateName, status, hasDraft, type, templates = [], updatedAt, ...more },
                i,
              ) => {
                const id = `${status === 'draft' ? 'draft:' : ''}${_id}`;
                return (
                  <TableRow key={i} selectable={false} style={{ overflow: 'visible', borderBottom: '1px solid #e0e0e0' }}>
                    <TableRowColumn colSpan="15" style={{ height: '40px', cursor: 'pointer' }}>
                      <div onClick={this.goToSecondary(id)}>
                        {!more.showEditNameConfirmButton ? (
                          <div className="flex-center">
                            <MasterIcon
                              color="rgba(0, 0, 0, 0.44)"
                              style={{ width: '18px', height: '18px' }}
                            />
                            &nbsp;{templateName}&nbsp;
                            <small>
                              {more.version > 1 ? `(v.${more.version})` : ''}
                            </small>
                          </div>
                        ) : (
                          <input
                            style={{ height: '32px', width: '90%' }}
                            autoFocus
                            onClick={e => e.stopPropagation()}
                            value={more.newTemplateName}
                            onChange={({ target: { value } }) =>
                              updateSecondaryTemplateProps({
                                id: _id,
                                newTemplateName: value,
                                errorText: '',
                              })
                            }
                          />
                        )}
                        <div>
                          {hasDraft ? (
                            <span style={{ marginLeft: '12px', color: 'red', zIndex: '200' }}>
                            This template has a{' '}
                              <Link
                                onClick={e => e.stopPropagation()}
                                to={`/contracting/master-template/draft:${_id}`}
                              >
                              draft
                            </Link>
                            .
                          </span>
                          ) : (
                            <span />
                          )}
                        </div>
                      </div>
                    </TableRowColumn>
                    {!(more.showDeleteConfirmButton || more.showEditNameConfirmButton)
                      ? [
                        <TableRowColumn
                          key="templates"
                          colSpan="3"
                          style={{ ...styles.cell, cursor: 'pointer' }}
                        >
                          <div
                            onClick={this.goToAssociatedTemplates(id)}
                          >
                            {templates.length}
                          </div>
                        </TableRowColumn>,
                        <TableRowColumn
                          key="status"
                          colSpan="3"
                          style={{ ...styles.cell, color: getTemplateStatusColor(status) }}
                        >
                          {status}
                        </TableRowColumn>,
                        <TableRowColumn key="ts" colSpan="3" style={styles.cell}>
                          {moment(updatedAt).calendar(null, {
                            sameDay: '[Today]',
                            lastDay: '[Yesterday]',
                            lastWeek: '[Last] dddd',
                            sameElse: 'DD/MM/YYYY',
                          })}
                        </TableRowColumn>,
                        <TableRowColumn key="actions" colSpan="2" style={styles.cell}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton
                              disabled={status === 'draft'}
                              tooltip="Apply to Templates"
                              tooltipPosition="top-right"
                              onClick={e => e.stopPropagation()}
                              style={{ padding: '0', width: '36px', height: '24px' }}
                              onTouchTap={() =>
                                push(`/contracting/master-template/${_id}/associate`)
                              }
                            >
                              <ApplyMasterIcon color="rgba(0, 0, 0, 0.54)" />
                            </IconButton>
                            <IconMenu
                              iconButtonElement={
                                <IconButton
                                  iconClassName="tc-icon-more-vert"
                                  iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', top: '2px' }}
                                  style={{ padding: '0', width: '24px', height: '24px' }}
                                />
                              }
                            >
                              <MenuItem
                                leftIcon={
                                  <FontIcon
                                    className="tc-icon-delete2"
                                    color={Boolean(templates.length) ? '#e0e0e0' : 'red'}
                                  />
                                }
                                primaryText="Delete Template"
                                disabled={Boolean(templates.length)}
                                onTouchTap={() =>
                                  updateSecondaryTemplateProps({ id: _id, showDeleteConfirmButton: true })
                                }
                              />
                              <MenuItem
                                leftIcon={
                                  <FontIcon className="tc-icon-mode_edit" color="#00bcd4" />
                                }
                                primaryText="Edit Template Name"
                                onTouchTap={() =>
                                  updateSecondaryTemplateProps({
                                    id: _id,
                                    showEditNameConfirmButton: true,
                                    newTemplateName: templateName,
                                  })
                                }
                              />
                            </IconMenu>
                          </div>
                        </TableRowColumn>,
                      ]
                      : [
                        <TableRowColumn
                          key="errorText"
                          colSpan="3"
                          style={{ color: 'red', padding: 0, whiteSpace: 'pre-wrap' }}
                        >
                          {more.errorText}
                        </TableRowColumn>,
                        <TableRowColumn key="editState" colSpan="8" style={{ padding: 0 }}>
                          <CancelConfirm
                            callingApi={more.savingName}
                            disableConfirmBtn={Boolean(
                              more.showEditNameConfirmButton &&
                              (!more.newTemplateName ||
                                !more.newTemplateName.trim() ||
                                more.newTemplateName === templateName ||
                                more.errorText),
                            )}
                            forDelete={more.showDeleteConfirmButton}
                            confirmLabel={
                              more.showDeleteConfirmButton ? 'Yes, Delete' : 'Confirm Change'
                            }
                            cancelLabel="Nevermind"
                            cancelFn={() =>
                              updateSecondaryTemplateProps({
                                id: _id,
                                showDeleteConfirmButton: false,
                                errorText: '',
                                showEditNameConfirmButton: false,
                                newTemplateName: '',
                              })
                            }
                            confirmFn={
                              more.showDeleteConfirmButton
                                ? () => deleteTemplate({ id: _id })
                                : () => renameTemplate({ id: _id, newName: more.newTemplateName })
                            }
                          />
                        </TableRowColumn>,
                      ]}
                  </TableRow>
                );
              },
            )}
          </TableBody>
        </Table>
      </div>
    );
  }
}

masterTemplateList.propTypes = {
  list: PropTypes.array,
  classes: PropTypes.object,
  push: PropTypes.func,
  updateSecondaryTemplateProps: PropTypes.func,
  toggleAssoicatedTemplates: PropTypes.func,
  deleteTemplate: PropTypes.func,
  renameTemplate: PropTypes.func,
};

const mapStateToProps = ({ contracting }) => ({
  ...contracting.masterTemplate.list,
});

const mapDispatchToProps = {
  push: pushAction,
  toggleAssoicatedTemplates: toggleAssoicatedTemplatesAction,
  updateSecondaryTemplateProps: updateSecondaryTemplatePropsAction,
  renameTemplate: renameTemplateAction,
  deleteTemplate: deleteTemplateAction,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectStyleSheet(styles)(masterTemplateList));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template-list/list.jsx